function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8875 15C14.1708 15 14.4104 14.9021 14.6062 14.7063C14.8021 14.5104 14.9 14.2708 14.9 13.9875C14.9 13.7042 14.8021 13.4646 14.6062 13.2688C14.4104 13.0729 14.1708 12.975 13.8875 12.975C13.6042 12.975 13.3646 13.0729 13.1687 13.2688C12.9729 13.4646 12.875 13.7042 12.875 13.9875C12.875 14.2708 12.9729 14.5104 13.1687 14.7063C13.3646 14.9021 13.6042 15 13.8875 15ZM13.175 11.8875H14.5875C14.5958 11.4208 14.65 11.075 14.75 10.85C14.85 10.625 15.0792 10.3333 15.4375 9.975C15.9208 9.5 16.2458 9.10833 16.4125 8.8C16.5792 8.49167 16.6625 8.13512 16.6625 7.73035C16.6625 7.00178 16.4042 6.40417 15.8875 5.9375C15.3708 5.47083 14.7014 5.2375 13.8792 5.2375C13.2182 5.2375 12.6418 5.42083 12.1501 5.7875C11.6584 6.15417 11.3125 6.64583 11.1125 7.2625L12.3875 7.7875C12.5375 7.3875 12.7404 7.08333 12.9962 6.875C13.252 6.66667 13.5449 6.5625 13.875 6.5625C14.2787 6.5625 14.6067 6.67613 14.859 6.90338C15.1113 7.13063 15.2375 7.43783 15.2375 7.825C15.2375 8.05833 15.1708 8.27917 15.0375 8.4875C14.9042 8.69583 14.6708 8.95417 14.3375 9.2625C13.8125 9.72083 13.4875 10.0896 13.3625 10.3688C13.2375 10.6479 13.175 11.1542 13.175 11.8875ZM7.875 18C7.35937 18 6.91796 17.8164 6.55078 17.4492C6.18359 17.082 6 16.6406 6 16.125V4.125C6 3.60937 6.18359 3.16796 6.55078 2.80078C6.91796 2.43359 7.35937 2.25 7.875 2.25H19.875C20.3906 2.25 20.832 2.43359 21.1992 2.80078C21.5664 3.16796 21.75 3.60937 21.75 4.125V16.125C21.75 16.6406 21.5664 17.082 21.1992 17.4492C20.832 17.8164 20.3906 18 19.875 18H7.875ZM4.125 21.75C3.60937 21.75 3.16796 21.5664 2.80077 21.1992C2.43359 20.832 2.25 20.3906 2.25 19.875V6H4.125V19.875H18V21.75H4.125Z",
  fill: "url(#paint0_linear_12149_5135)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_12149_5135",
  x1: 8,
  y1: 2,
  x2: 16.5,
  y2: 19.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})));
function SvgFaqActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqActive);
export default __webpack_public_path__ + "static/media/faq-active.c7329139df36d5d7ec01f940489712b5.svg";
export { ForwardRef as ReactComponent };